module.exports = __webpack_public_path__ + "img/load.a6cd4c51.gif";